// API Base URL for Main Site requests
export const API_BASE = (import.meta.env.VITE_API_URL as string) || 
  (import.meta.env.PROD ? 'https://pending-clouds-art-api.onrender.com' : '');
